export function GainVer(ver) {
    this.ver = ver;
    //不抽取不审核
    this.isVer1 = function() {
        if (this.ver.indexOf('m') > -1) {
            return true;
        }

        return this.ver == 'v1101' || this.ver == 'v1001' || this.ver == 'v0101';
    };
    //抽取不审核
    this.isVer2 = function() {
        return this.ver == 'v1011' || this.ver == 'v1010';
    };
    //抽取审核
    this.isVer3 = function() {
        return (
            this.ver == 'v1111' ||
            this.ver == 'v1110' ||
            this.ver == 'v0111' ||
            this.ver == 'v0110'
        );
    };
}